import axios from '@/user/axios';
import { fileDownload } from '@/utils';

const moduleAmcAffinityReports = {
  namespaced: true,
  state: {
    reportTasks: [],
    reports: [],
    categoriesList: [],
    ecUserCategories: {},
    minStartDay: null,
  },
  mutations: {
    SET_REPORT_TASKS(state, payload) {
      state.reportTasks = payload;
    },
    SET_REPORTS_DATA(state, payload) {
      state.reports = payload;
    },
    SET_CATEGORIES_LIST(state, payload) {
      state.categoriesList = payload
    },
    SET_EC_USER_CATEGORY_LIST(state, payload) {
      state.ecUserCategories = payload
    },
    SET_MIN_START_DAY(state, payload) {
      state.minStartDay = payload;
    },
  },
  actions: {
    listReportTasks(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId;
          const res = await axios.get(`/api/amc-reports/affinity-report/task/${sellerId}`, {
            params: payload,
          });
          if (res.data.success) {
            context.commit('SET_REPORT_TASKS', res.data.data);
          }
          resolve(res);
        } catch (err) {
          reject(err);
        }
      });
    },
    updateReportTask(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId;
          const res = await axios.put(`/api/amc-reports/affinity-report/task/${sellerId}/${payload.taskId}`, payload);
          resolve(res);
        } catch (err) {
          reject(err);
        }
      });
    },
    deleteReportTask(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId;
          const res = await axios.delete(`/api/amc-reports/affinity-report/task/${sellerId}/${payload.taskId}`, payload);
          resolve(res);
        } catch (err) {
          reject(err);
        }
      });
    },
    addReportTask(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId;
          const res = await axios.post(`/api/amc-reports/affinity-report/task/${sellerId}`, payload);
          resolve(res);
        } catch (err) {
          reject(err);
        }
      });
    },
    fetchReports(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId;
          const res = await axios.get(`/api/amc-reports/affinity-report/reports/${sellerId}`, {
            params: payload,
          });
          if (res.data.success) {
            context.commit('SET_REPORTS_DATA', res.data.data);
          }
          resolve(res);
        } catch (err) {
          reject(err);
        }
      });
    },
    downloadCSV(context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId;
        try {
          const res = await axios.get(`/api/amc-reports/affinity-report/download/${sellerId}`, {
            responseType: 'blob',
            params: { taskId: payload.taskId },
          });
          const fileName = `AMCアフィニティレポート_${payload.reportName}.csv`;
          fileDownload(res.data, fileName);
          resolve(res);
        } catch (err) {
          reject(err);
        }
      });
    },
    fetchCategories(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/affinity-report/categories/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_CATEGORIES_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listEcUserCategories(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/affinity-report/ec-user-category/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_EC_USER_CATEGORY_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    fetchMinStartDay(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId;
          const res = await axios.get(`/api/amc-reports/affinity-report/start-day/${sellerId}`, {
            params: payload,
          });
          if (res.data.success) {
            context.commit('SET_MIN_START_DAY', res.data.data.startDay);
          }
          resolve(res);
        } catch (err) {
          reject(err);
        }
      });
    },
  },
};

export default moduleAmcAffinityReports;
